// src/App.js (User App)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProgramLandingPage from './pages/ProgramLandingPage';
import UserAuthCallbackPage from './pages/UserAuthCallbackPage'; // For Google OAuth callback
import { ParticipantAuthProvider, useParticipantAuth } from './context/ParticipantAuthContext';
import ParticipantEmailConfirmationPage from './pages/ParticipantEmailConfirmationPage';
import ParticipantProfilePage from './pages/ParticipantProfilePage'; // <-- IMPORT FOR SLOT 29

import './App.css'; // Default App.css from CRA
import './styles/Modal.css'; // Import Modal styles globally for User App

// Placeholder for a protected route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useParticipantAuth();
  
  if (loading) {
    // You can render a loading spinner or a blank page while auth state is being determined
    return <div style={{textAlign: 'center', padding: '50px'}}>Initializing session...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/" replace />; 
  // If not authenticated, redirect to landing. 
  // The landing page will show login/register buttons if a program is specified.
};

function AppContent() {
  return (
    <div className="App"> {/* Basic wrapper */}
      <Routes>
        {/* ProgramLandingPage will handle displaying program info and triggering auth modal */}
        <Route path="/" element={<ProgramLandingPage />} />

        <Route path="/confirm-participant-email/:token" element={<ParticipantEmailConfirmationPage />} />
        
        {/* OAuth Callback route - this page handles the redirect from Google */}
        <Route path="/auth/callback/participant/google" element={<UserAuthCallbackPage />} />

        {/* Profile page - will be protected - UPDATED FOR SLOT 29 */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ParticipantProfilePage /> {/* <-- USE THE ACTUAL PROFILE PAGE COMPONENT */}
            </ProtectedRoute>
          }
        />

        {/* Removed /login and /register routes as they are now modal-based */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ParticipantAuthProvider>
        <AppContent />
      </ParticipantAuthProvider>
    </Router>
  );
}

export default App;



// // src/App.js (User App)
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import ProgramLandingPage from './pages/ProgramLandingPage';
// import UserAuthCallbackPage from './pages/UserAuthCallbackPage'; // For Google OAuth callback
// import { ParticipantAuthProvider, useParticipantAuth } from './context/ParticipantAuthContext';
// import ParticipantEmailConfirmationPage from './pages/ParticipantEmailConfirmationPage';


// import './App.css'; // Default App.css from CRA
// import './styles/Modal.css'; // Import Modal styles globally for User App

// // Placeholder for a protected route component
// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, loading } = useParticipantAuth();
  
//   if (loading) {
//     // You can render a loading spinner or a blank page while auth state is being determined
//     return <div style={{textAlign: 'center', padding: '50px'}}>Initializing session...</div>;
//   }

//   return isAuthenticated ? children : <Navigate to="/" replace />; 
//   // If not authenticated, redirect to landing. 
//   // The landing page will show login/register buttons if a program is specified.
// };

// function AppContent() {
//   return (
//     <div className="App"> {/* Basic wrapper */}
//       <Routes>
//         {/* ProgramLandingPage will handle displaying program info and triggering auth modal */}
//         <Route path="/" element={<ProgramLandingPage />} />

//         <Route path="/confirm-participant-email/:token" element={<ParticipantEmailConfirmationPage />} />
        
//         {/* OAuth Callback route - this page handles the redirect from Google */}
//         <Route path="/auth/callback/participant/google" element={<UserAuthCallbackPage />} />

//         {/* Profile page - will be protected */}
//         <Route
//           path="/profile"
//           element={
//             <ProtectedRoute>
//               <div style={{textAlign: 'center', padding: '50px'}}>
//                 <h2>Participant Profile</h2>
//                 <p>Welcome! You are logged in.</p>
//                 <p>(Profile content from Slot 29 will go here)</p>
//                 {/* Add a logout button or similar here for testing */}
//               </div>
//             </ProtectedRoute>
//           }
//         />

//         {/* Removed /login and /register routes as they are now modal-based */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </div>
//   );
// }

// function App() {
//   return (
//     <Router>
//       <ParticipantAuthProvider>
//         <AppContent />
//       </ParticipantAuthProvider>
//     </Router>
//   );
// }

// export default App;